import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['exportForm', 'spinner']

  showSpinner() {
    this.exportFormTarget.classList.add('d-none')
    this.spinnerTarget.classList.remove('d-none')
  }

  restoreForm() {
    this.spinnerTarget.classList.add('d-none')
    this.exportFormTarget.classList.remove('d-none')
  }

  handleResponse(event) {
    if (!event.detail.success) this.restoreForm()
  }
}
